import {
  FETCH_LEADER_ALERTS,
  FETCH_LEADER_ALERTS_SUCCESS,
  FETCH_LEADER_ALERTS_FAILED,
  EDIT_LEADER_ALERT,
  FETCH_LEADER_WEEKLY_HISTORY,
  FETCH_LEADER_WEEKLY_HISTORY_SUCCESS,
  FETCH_LEADER_WEEKLY_HISTORY_FAILED,
} from '../store/types';

const initialState = {
  loading: false,
  alerts: [],
  error: null,
  historyLoading: false,
  history: [],
  historyError: null,
};

export const leaderAlertreducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LEADER_ALERTS:
      return { ...state, loading: true, error: null };
    case FETCH_LEADER_ALERTS_SUCCESS:
      return { ...state, loading: false, alerts: action.payload || [], error: null };
    case FETCH_LEADER_ALERTS_FAILED:
      return { ...state, loading: false, error: action.payload, alerts: [] };
    case EDIT_LEADER_ALERT:
      return state;
    case FETCH_LEADER_WEEKLY_HISTORY:
      return { ...state, historyLoading: true, historyError: null };
    case FETCH_LEADER_WEEKLY_HISTORY_SUCCESS:
      return {
        ...state,
        historyLoading: false,
        history: action.payload || [],
        historyError: null,
      };
    case FETCH_LEADER_WEEKLY_HISTORY_FAILED:
      return {
        ...state,
        historyLoading: false,
        historyError: action.payload,
        history: [],
      };
    default:
      return state;
  }
};
